import { RecentService } from "app/services/recent/recentService";

interface AutocompleteRecentSchema {
    name: string;
    image: string;
    type: string;
}

export const RECENT_ITEMS_TYPE = "recent";

export const getRecentItems = (excludeList: string[] = []): AutocompleteRecentSchema[] => {
    const recentRawItems = RecentService.getRecentsWebsites().filter(
        (recent) => !excludeList.includes(recent.data.mainItem),
    );

    return recentRawItems.map((item) => ({
        name: item.data.mainItem,
        image: item.data.resources.mainItemFavIcon,
        type: RECENT_ITEMS_TYPE,
    }));
};
